import React, { FC } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { globalTheme } from '@cld/component-theme';
import { website } from '@cld/typography';
import { getAssetUrl } from '../../../../utils';
import { messages } from '../../../../i18n';
import { Link } from './Link';

const Root = styled.div`
  background: ${globalTheme.palette.brand.darkBlue};
  padding: calc(${globalTheme.spacing.lg} * 2) calc(${globalTheme.spacing.lg} * 10);
  text-align: center;
`;

const Heading = styled.h2`
  ${website.headlines.xl.contrastInvert};
`;

const LinksContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: ${globalTheme.spacing.xxl} 0;
`;

export const Links: FC = () => (
  <Root>
    <Heading>
      <FormattedMessage {...messages['landing.linksSection.heading']} />
    </Heading>

    <LinksContainer>
      <Link
        label="SalesForce"
        img={getAssetUrl('links/salesforce.svg')}
        url="https://cloudinary.com/documentation/salesforce_page_designer_cartridge_integration"
        data-test="links-section-salesforce-link"
      />
      <Link
        label="WordPress"
        img={getAssetUrl('links/wordpress.svg')}
        url="https://cloudinary.com/documentation/wordpress_integration"
        data-test="links-section-wordpress-link"
      />
      <Link
        label="Contentful"
        img={getAssetUrl('links/contentful.svg')}
        url="https://www.contentful.com/marketplace/app/cloudinary/"
        data-test="links-section-contentful-link"
      />
      <Link
        label="NetlifyCMS"
        img={getAssetUrl('links/netlify-cms.svg')}
        url="https://cloudinary.com/blog/managing_visual_media_with_the_cloudinary_netlify_integration"
        data-test="links-section-netlify-cms-link"
      />
      <Link
        label="Forestry.io"
        img={getAssetUrl('links/forestry-io.svg')}
        url="https://cloudinary.com/blog/why_we_integrated_cloudinary_at_forestry_io"
        data-test="links-section-forestry-io-link"
      />
      <Link
        label="Magento"
        img={getAssetUrl('links/magento.svg')}
        url="https://cloudinary.com/documentation/magento_integration"
        data-test="links-section-magento-link"
      />
    </LinksContainer>
  </Root>
);
